<div class="d-flex flex-column bg-login m-0">
  <div class="w-25 mx-auto">
    <div class="card px-2">
      <div class="card-header text-center">
        <div class="mx-auto logo-login mb-4"></div>
        <h5 class="mb-1">{{ "DCO.Login_LogInTitle" | translate }}<!--Iniciar sesión--></h5>
        <p class="text-muted">{{ "DCO.Login_LogInDescription" | translate }}<!--Ingrese sus credenciales para acceder al portal--></p>
      </div>
      <div class="card-body">
        <form class="mb-5" [formGroup]="loginForm" (ngSubmit)="loginForm.valid && onSubmit()" novalidate>
          <div class="form-group mb-4">
            <label class="form-label fw-semibold mb-2" for="username">{{ "DCO.Login_UserName" | translate }}</label>
            <input type="username" class="form-control" formControlName="username" />
          </div>
          <div class="form-group mb-3">
            <label class="form-label fw-semibold mb-2" for="password">{{ "DCO.Login_Password" | translate }}</label>
            <input type="password" matInput class="form-control" placeholder="" formControlName="pw" />
          </div>
          <div *ngIf="isLoginFailed" class="alert alert-danger" role="alert">
              {{ "DCO.Login_Login_Failed" | translate }} {{ errorMessage }}
          </div>
          <div class="form-group mb-3">
            <button [disabled]="!loginForm.valid" type="submit" class="btn btn-dark rounded-2 w-100 m-0">
              {{ "DCO.Login_LoginButton" | translate }}
            </button>
          </div>
          <div *ngIf="allowPasswordRecovery" class="text-center">
            <a [routerLink]="code" class="btn btn-link text-dark">{{
                "DCO.Login_ForgotPassword_Message" | translate
                }}</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>